import api from './base'
let url = '/api/reserve';

/**
 * 获取活动公告
 */
export const getActivityNotice = (activity_id) => api.apiPost(url + '/getActivityNotice', {activity_id});

/**
 * 获取活动图片
 */
export const getActivityBanner0 = (activity_id) => api.apiPost(url + '/getActivityBanner', {activity_id, img_type: 0});
/**
 * 获取活动图片
 */
export const getActivityBanner1 = (activity_id) => api.apiPost(url + '/getActivityBanner', {activity_id, img_type: 1});

/**
 * 获取园区详细信息
 */
export const getParkInfo = (park_id) => api.apiPost(url + '/getParkInfo', {park_id});

/**
 * 查看活动信息及时间段信息
 */
export const getActivityInfo = (activity_id) => api.apiPost(url + '/getActivityInfo', {activity_id});

/**
 * 查看当前已预约人数
 */
export const getActivityOrderNum = (activity_id, activity_time_id, activity_date) => api.apiPost(url + '/getActivityOrderNum', {activity_id, activity_time_id, activity_date});

/**
 * 获取健康状况问题
 */
export const getHealthQuestion = (activity_id) => api.apiPost(url + '/getHealthQuestion', {activity_id});

/**
 * 添加预约信息
 */
export const addActivityRecord = (activity_id, activity_time_id, activity_date, member_arr) => api.apiPost(url + '/addActivityRecord', {activity_id, activity_time_id, activity_date, member_arr});

/**
 * 修改预约信息
 */
export const editActivityRecord = (activity_record_id, member_arr) => api.apiPost(url + '/editActivityRecord', {activity_record_id, member_arr});

/**
 * 修改预约信息
 */
export const isDoActivityRecord = (activity_id, activity_time_id, activity_date) => api.apiPost(url + '/isDoActivityRecord', {activity_id, activity_time_id, activity_date});

/**
 * 获取预约记录
 */
export const getActivityRecord = (activity_id, page, page_size) => api.apiPost(url + '/getActivityRecord', {activity_id, page, page_size});

/**
 * 获取预约详情
 */
export const getActivityRecordDetails = (activity_record_id) => api.apiPost(url + '/getActivityRecordDetails', {activity_record_id});

/**
 * 取消预约
 */
export const delActivityRecord = (activity_record_id) => api.apiPost(url + '/delActivityRecord', {activity_record_id});

/**
 * 获取当前时间点的预约活动
 */
export const getNowActivityRecord = (activity_id) => api.apiPost(url + '/getNowActivityRecord', {activity_id});

/**
 * 验票通过
 */
export const checkActivityRecord = (activity_record_id, t_data) => api.apiPost(url + '/checkActivityRecord', {activity_record_id, t_data});

